<div fxLayout="column">
  <div *ngIf="label.length > 0" class="input-label">{{ label }}</div>
  <div *ngIf="disabled && !useInput" class="disabled" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon>schedule</mat-icon>
    {{ defaultTime }}
  </div>

  <ngx-timepicker-field
    #timePicker
    *ngIf="!disabled && !useInput; else input"
    [buttonAlign]="buttonAlign"
    [minutesGap]="minutesGap"
    [defaultTime]="defaultTime"
    [format]="format"
    [controlOnly]="controlOnly"
    (timeChanged)="timeChangedHandler($event)"
    [disabled]="disabled2"
  ></ngx-timepicker-field>

  <ng-template #input>
    <input
      id="time"
      type="time"
      [value]="defaultTime"
      [disabled]="disabled ? true : false"
      (change)="timeChangedHandler($any($event.target).value)"
    />
  </ng-template>
</div>
